import React from 'react';
import { useParams } from 'react-router-dom';
import Lock from '../components/organism/Lock';
import { hasPermission, useAccessControlStore } from '../stores/accessControlStore';

interface IProtectedRoute {
  modulesAllowed?: string[];
  element: React.JSX.Element;
  moduleFromParam?: string | null;
  customLock?: React.JSX.Element;
}

const verifyDiscipline = {
  'fisiologia-superior': 'universitario-navegacao-livre-fisiologia-humana',
  'genetica-superior': 'universitario-navegacao-livre-genetica',
  'anatomia-superior': 'universitario-navegacao-livre-anatomia',
  'bioquimica-superior': 'universitario-navegacao-livre-bioquimica',
  'microbiologia-superior': 'universitario-navegacao-livre-microbiologia',
  'patologia-superior': 'universitario-navegacao-livre-patologia',
  'parasitologia-superior': 'universitario-navegacao-livre-parasitologia',
  'histologia-humana-superior': 'universitario-navegacao-livre-histologia-humana',
  'imunologia-superior': 'universitario-navegacao-livre-imunologia',
  'embriologia-superior': 'universitario-navegacao-livre-embriologia',
  'farmacologia-superior': 'universitario-navegacao-livre-farmacologia',
}

const NavigationProtectedRoute = React.memo(({ element, customLock }: IProtectedRoute) => {
    const params = useParams();
    const discipline = params.discipline || null;
    let moduleName = discipline ? verifyDiscipline[discipline as keyof typeof verifyDiscipline] : null;

    const { permissions } = useAccessControlStore();

    if(permissions.includes('universitario-navegacao-livre')) {
      moduleName = 'universitario-navegacao-livre';
    }

    if(permissions.includes('universitario-navegacao-livre-free')) {
      moduleName = 'universitario-navegacao-livre-free';
    }

    if (moduleName && hasPermission([moduleName])) {
      return element;
    }

    if (customLock) {
      return customLock;
    }

    return <Lock />;
  }
);

NavigationProtectedRoute.displayName = 'NavigationProtectedRoute';

export default NavigationProtectedRoute;
